import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './Tabs.styles';
var Tabs = function Tabs(_ref) {
  var _tabs$activeTab;
  var tabs = _ref.tabs;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  if (!tabs) {
    return null;
  }
  return React.createElement(S.TabsContainer, null, React.createElement(S.TabList, null, tabs.map(function (tab, index) {
    return React.createElement(S.Tab, {
      key: tab.label,
      role: "tab",
      onClick: function onClick() {
        return setActiveTab(index);
      },
      isActive: activeTab === index,
      tabIndex: 0
    }, tab.label);
  })), React.createElement(S.TabContent, null, ((_tabs$activeTab = tabs[activeTab]) == null ? void 0 : _tabs$activeTab.content) || null));
};
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
} : void 0;
export default Tabs;